class GameEntity {
  constructor(game, width, height, color, velocityY, image) {
    this.game = game;

    this.width = width;
    this.height = height;

    this.color = color;

    this.velocityY = velocityY;
    
    this.markedForDeletion = false;

    this.image = new Image();
    this.image.src = image;
  }

  update(deltaTime) {
    this.y += this.velocityY * deltaTime;

    if (this.y > this.game.height) this.markedForDeletion = true;
  }

  draw(ctx) {
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}

export { GameEntity };
